/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Field_ReplyInputs */



/**
* | output |
* | --- |
* | "Reply" |
*
* @param {Transcript_Export_Field_ReplyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_field_reply = /** @type {((inputs?: Transcript_Export_Field_ReplyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Field_ReplyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reply")
	if (locale === "de") return /** @type {LocalizedString} */ ("Reply")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reply")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Reply")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reply")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Reply")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Reply")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Reply")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reply")
	return /** @type {LocalizedString} */ ("Reply")
});